import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import React, { Component } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { NavLink } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { withRouter } from "../../../withRouter";
import dpTextLogo from "../../../assets/img/dptextLogo.png";
import "./VerifyOTP.css";
import FetchServerData from "../../../provider/FetchServerData";
import {
  ResentOTP_Url,
  StaticDPText_Url,
} from "../../../provider/ServiceUrl";
import store from "../../../redux/store";
import ActiveMenuAction from "../../../redux/activeMenu/ActiveMenuAction";
import AppUserDataAction from "../../../redux/appUserData/AppUserDataAction";
import SelectedTabAction from "../../../redux/selectedTab/SelectedTabAction";
import staticDataAction from "../../../redux/staticData/staticDataAction";
import PtsAlert from "../ptsAlert/PtsAlert";
import AccountSettingDataAction from "../../../redux/accountSetting/AccountSettingDataAction";
import CrmIntegrationAction from "../../../redux/crmIntegration/CrmIntegrationAction";
import Utils from "../../../provider/Utils";

export class DpTextVerifyOTP extends Component {
  header = store.getState().header.header;
  constructor(props) {
    super(props);

    let businessDomain = "";
    let sendOtpByEmail = false;
    let sendOtpByText = false;
    let resendOtpByEmail = false;
    let resendOtpByText = false;
    let rememberMe = false;
    let password = "";
    if (props.state) {
      businessDomain = props.state.businessDomain;
      sendOtpByEmail = props.state.sendOtpByEmail;
      sendOtpByText = props.state.sendOtpByText;
      resendOtpByEmail = props.state.resendOtpByEmail;
      resendOtpByText = props.state.resendOtpByText;
      rememberMe = props.state.rememberMe;
      password = props.state.password;
    }

    this.state = {
      verifyOtp: "",
      value1: "",
      value1Ref: React.createRef(),
      value2: "",
      value2Ref: React.createRef(),
      value3: "",
      value3Ref: React.createRef(),
      value4: "",
      value4Ref: React.createRef(),
      value5: "",
      value5Ref: React.createRef(),
      value6: "",
      value6Ref: React.createRef(),
      businessDomain: businessDomain,
      sendOtpByEmail: sendOtpByEmail,
      sendOtpByText: sendOtpByText,
      resendOtpByEmail: resendOtpByEmail,
      resendOtpByText: resendOtpByText,
      rememberMe: rememberMe,
      password: password,
      error: false,
      render: false,
    };
  }

  componentDidMount() {
    this.state.value1Ref.current.focus();
  }

  handleValueChange = async (e) => {
    const { name, value } = e.target;

    if (e.key === "Backspace") {
      return;
    }
    if (value.length > 1) {
      PtsAlert.error("Please enter a single digit");
      return;
    }

    await this.setState({ [name]: value });

    switch (name) {
      case "value1":
        this.value2Focus();
        this.value2Select();
        break;
      case "value2":
        this.value3Focus();
        this.value3Select();
        break;
      case "value3":
        this.value4Focus();
        this.value4Select();
        break;
      case "value4":
        this.value5Focus();
        this.value5Select();
        break;
      case "value5":
        this.value6Focus();
        this.value6Select();
        break;
      case "value6":
        this.verifyOTPInBackend();
        break;
      default:
        break;
    }
  };

  handleKeyUp = (e) => {
    const { name, key } = e.target;
    if (key === "Enter") {
      this.verifyOTPInBackend();
    } else if (key === "ArrowLeft") {
      const map = {
        value2: this.value1Ref,
        value3: this.value2Ref,
        value4: this.value3Ref,
        value5: this.value4Ref,
        value6: this.value5Ref,
      };
      if (map[name]) map[name].current.focus();
    } else if (key === "ArrowRight") {
      const map = {
        value1: this.value2Ref,
        value2: this.value3Ref,
        value3: this.value4Ref,
        value4: this.value5Ref,
        value5: this.value6Ref,
      };
      if (map[name]) map[name].current.focus();
    }
  };

  handleKeyDown = (e) => {
    if (e.key !== "Backspace") return;

    e.preventDefault();
    const { name, value } = e.target;

    const prevMap = {
      value2: this.state.value1Ref,
      value3: this.state.value2Ref,
      value4: this.state.value3Ref,
      value5: this.state.value4Ref,
      value6: this.state.value5Ref,
    };

    if (!value) {
      const prev = prevMap[name];
      if (prev?.current) {
        prev.current.focus();
      }
      return;
    }

    this.setState({ [name]: "" });
  };


  value1Focus = () => {
    this.state.value1Ref.current.focus();
  };
  value2Focus = () => {
    this.state.value2Ref.current.focus();
  };
  value3Focus = () => {
    this.state.value3Ref.current.focus();
  };
  value4Focus = () => {
    this.state.value4Ref.current.focus();
  };
  value5Focus = () => {
    this.state.value5Ref.current.focus();
  };
  value6Focus = () => {
    this.state.value6Ref.current.focus();
  };

  value1Select = () => {
    this.state.value1Ref.current.select();
  };
  value2Select = () => {
    this.state.value2Ref.current.select();
  };
  value3Select = () => {
    this.state.value3Ref.current.select();
  };
  value4Select = () => {
    this.state.value4Ref.current.select();
  };
  value5Select = () => {
    this.state.value5Ref.current.select();
  };
  value6Select = () => {
    this.state.value6Ref.current.select();
  };

  renderInputBox = (name, ref) => {
    return (
      <Col md={2} style={{ padding: "0rem 1rem 0rem 0rem" }}>
        <input
          type="number"
          autoFocus={true}
          ref={this.state[ref]}
          className="form-control otpFormControlInput"
          id={"otpFormControlInput-" + name}
          maxLength="1"
          name={name}
          value={this.state[name]}
          onKeyUp={this.handleKeyUp}
          onKeyDown={this.handleKeyDown}
          onChange={this.handleValueChange}
          aria-describedby="defaultFormControlHelp"
        />
      </Col>
    );
  };

  verifyOTPInBackend() {
    const { value1, value2, value3, value4, value5, value6 } = this.state;

    const otpValue = `${value1}${value2}${value3}${value4}${value5}${value6}`;

    if (otpValue.length !== 6) {
      return;
    }
    const postObject = {
      header: this.header,
      otp: otpValue,
    };
    FetchServerData.callPostService("/appuserms/verifyOtp", postObject).then(
      (response) => {
        if (response.status === "SUCCESS") {
          let output = response.data;
          this.processLoginSuccess(output);
          if (output.appuser.isRememberMe) {
            // localStorage.setItem("dptextUserId", output.appuser.email);
            // localStorage.setItem("dptextPassword", this.state.password);
            // localStorage.setItem(
            //   "dptextSelectedOption",
            //   JSON.stringify(output.appuser.tenant)
            // );
            localStorage.setItem(
              "dptextRememberMe",
              output.appuser.isRememberMe
            );
            localStorage.setItem("dptextHeader", JSON.stringify(output.header));
          } else {
            localStorage.removeItem("dptextHeader");
            // localStorage.removeItem("dptextUserId");
            // localStorage.removeItem("dptextPassword");
            // localStorage.removeItem("dptextSelectedOption");
            localStorage.removeItem("dptextRememberMe");
          }
        } else {
          if (
            response.message &&
            response.message.includes("Your account is locked")
          ) {
            this.props.navigate("/signin");
          } else {
          }
        }
      }
    );
  }

  processLoginSuccess(output_data) {
    store.dispatch(AppUserDataAction.setUserData(output_data));
    store.dispatch(AppUserDataAction.setUsage(output_data.smsCredits));
    store.dispatch(AppUserDataAction.setTollfreeNumber(output_data.tollfreeNumber));
    store.dispatch(AppUserDataAction.setTollfreeNumberStatus(output_data.tollFreeNumberStatus));
    store.dispatch(
      CrmIntegrationAction.setCrmIntegration(output_data.crmIntegration)
    );
    store.dispatch(
      AppUserDataAction.setOrganization(output_data.appuser?.organization)
    );
    let accountSetting = output_data?.accountSetting;
    store.dispatch(AccountSettingDataAction.setAccountSettingData({ accountSetting }));
    let logoData = {
      logo: output_data.appuser?.organization?.logo
        ? output_data.appuser?.organization?.logo
        : "",
      logoFilename: output_data.appuser?.organization?.logoFilename
        ? output_data.appuser?.organization?.logoFilename
        : "",
      logoFileextension: output_data.appuser?.organization?.logoFileextension
        ? output_data.appuser?.organization?.logoFileextension
        : "",
    };
    store.dispatch(AppUserDataAction.setLogo(logoData));
    if (output_data.isTollfreeNumberPurchased === true) {
      store.dispatch(SelectedTabAction.setSelectedTab(0));
    } else {
      store.dispatch(SelectedTabAction.setSelectedTab(1));
      if (output_data.cmpaigningInfoError) {
      }
    }
    let header = this.header;
    this.loadDashboardPage(header, output_data);
  }
  async loadDashboardPage(header, output) {
    let menus = output.appuser?.profile?.menus.sort(
      (a, b) => a.displaysequence - b.displaysequence
    );
    await this.setStaticData(header);
    store.dispatch(
      ActiveMenuAction.setActiveMenu(Utils.getArrayElement(menus, 0)?.pageid)
    );
    for (let i = 0; i < menus.length; i++) {
      const menu = menus[i];
      if (menu.isactive) {
        this.props.navigate(menu.pageid);
        break;
      }
    }
  }
  async setStaticData(header) {
    const postObject = {
      header: header,
    };

    FetchServerData.callPostService(StaticDPText_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          store.dispatch(staticDataAction.setStaticData(output.data));
        } else {
        }
      }
    );
  }

  ResendVerifyOTP() {
    if (!this.state.resendOtpByEmail && !this.state.resendOtpByText) {
      this.setState({
        error: true,
      });
      return;
    }
    const postObject = {
      header: this.header,
      sendOtpByEmail: this.state.resendOtpByEmail,
      sendOtpByText: this.state.resendOtpByText,
    };
    FetchServerData.callPostService(ResentOTP_Url, postObject).then(
      (response) => {
        if (response.status === "SUCCESS") {
          PtsAlert.success(response.message);
          this.state.value1Ref.current.focus();
          this.setState({
            value1: "",
            value2: "",
            value3: "",
            value4: "",
            value5: "",
            value6: "",
          });
        } else {
        }
      }
    );
  }
  handleResendOtpByEmailChange(e) {
    this.setState({ resendOtpByEmail: e.target.checked, error: false });
  }
  handleResendOtpByTextChange(e) {
    this.setState({ resendOtpByText: e.target.checked, error: false });
  }

  renderOtpSentMessage() {
    const { sendOtpByEmail, sendOtpByText } = this.state;
    if (sendOtpByEmail && sendOtpByText) {
      return <p>A verification code has been sent to your mobile and email.</p>;
    } else if (sendOtpByEmail) {
      return <p>A verification code has been sent to your email.</p>;
    } else if (sendOtpByText) {
      return <p>A verification code has been sent to your mobile.</p>;
    }
    return null;
  }

  render() {
    return (
      <div className="authentication-wrapper authentication-cover">
        <div className="authentication-inner row m-0" id="signIn">
          <header
            id="dptextheader"
            className="fixed-top d-flex align-items-center"
          >
            <div className="container d-flex align-items-center justify-content-between">
              <div className="logo">
                <img
                  src={dpTextLogo}
                  alt=""
                  style={{ width: "auto", height: "60px" }}
                />
              </div>
              <nav id="navbar" className="navbar">
                <ul>
                  <li className="active">
                    <a
                      className="nav-link scrollto"
                      href="/dptextSignin"
                      style={{ color: "#53a5ff" }}
                    >
                      Login
                    </a>
                  </li>
                  <li>
                    <a
                      className="nav-link scrollto"
                      href="/dptextSignup"
                      style={{ color: "#53a5ff" }}
                    >
                      Sign Up
                    </a>
                  </li>
                </ul>
                <i className="bi bi-list mobile-nav-toggle" />
              </nav>
            </div>
          </header>
          <div className="d-flex col-12 col-lg-12 col-xl-12 align-items-center authentication-bg p-sm-5 p-4">
            <div className="w-px-400 mx-auto">
              <ValidatorForm
                className="text-start"
                ref="form"
                onSubmit={this.verifyOTPInBackend.bind(this)}
              >
                <div className="signinHeding">Account Verification</div>
                <div className="mb-2 mt-2">
                  {this.renderOtpSentMessage()}
                  <label className="form-label" htmlFor="multiStepsPass">
                    Enter Verification Code
                  </label>
                  <Row style={{ margin: "0.6em 0em" }}>
                    {this.renderInputBox("value1", "value1Ref")}
                    {this.renderInputBox("value2", "value2Ref")}
                    {this.renderInputBox("value3", "value3Ref")}
                    {this.renderInputBox("value4", "value4Ref")}
                    {this.renderInputBox("value5", "value5Ref")}
                    {this.renderInputBox("value6", "value6Ref")}
                  </Row>
                </div>
                <div
                  className="row d-flex"
                  style={{ padding: "0px 16px 0px 10px" }}
                >
                  <div class="col-md-6 align-self-center text-start ps-0">
                    <NavLink className="pt-1" to="/dptextSignin">
                      <ArrowBackIosNewIcon />
                      Back
                    </NavLink>
                  </div>
                  <div className="col-md-6 text-end align-self-center">
                    <NavLink
                      className="naveLink"
                      onClick={this.ResendVerifyOTP.bind(this)}
                      style={{ float: "right" }}
                    >
                      <span>Resend Code</span>
                    </NavLink>
                  </div>
                </div>
                {/* <button
                    className="dptextSiginButton d-grid w-100"
                    type="submit"
                  >
                    {" "}
                    Next
                  </button> */}
                {/* <div className="d-flex flex-row pt-3">
                    <div class="col-md-4 align-self-start">
                      <NavLink className="pt-1" to="/dptextSignin">
                        <ArrowBackIosNewIcon />
                        Back
                      </NavLink>
                    </div>
                  </div> */}
              </ValidatorForm>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(DpTextVerifyOTP);
